<div class="container">
  <div class="first-section">
    <div class="header-container">
      <span class="px-heading-3 first">{{ moduleData && moduleData.module_id ? 'Update' : 'New' }} feature
        module</span>
      <i class="material-icons close-icon" (click)="closeDialog()">close</i>
    </div>
  </div>
  <div class="section">
    <div class="px-heading-4">Feature module details</div>
    <div class="create-native-nudge-form">
      <form #moduleForm="ngForm" novalidate class="form">
        <mat-dialog-content style="max-height: 300px !important;">
          <div class="nxt-input">
            <mat-label class="nxt-label">Feature module name <span class="asterisk">*</span></mat-label>
            <div class="nxt-input-infix">
              <mat-form-field appearance="none" class="w-100" [hideRequiredMarker]="true">
                <input matInput type="text" name="moduleName" placeholder="Name" [(ngModel)]="moduleData.name"
                  #name="ngModel" required pattern="^[a-zA-Z0-9-_]*$"
                  [disabled]="(moduleData && moduleData.module_id)?true:false">
                <mat-error>
                  <span *ngIf="name?.errors?.required && name.touched">
                    Please assign a name.
                  </span>
                  <span *ngIf="name?.errors?.pattern">
                    No spaces or special characters
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="nxt-input">
            <mat-label class="nxt-label">Description</mat-label>
            <div class="nxt-input-infix">
              <mat-form-field appearance="none" class="w-100" [hideRequiredMarker]="true">
                <input matInput #input name="moduleDescription" placeholder="Description" [(ngModel)]="moduleData.desc">
                <mat-hint align="end">{{input.value?.length || 0}}/300 characters</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </mat-dialog-content>
      </form>
    </div>
  </div>
  <div class=" footer">
    <button [disabled]="!moduleForm.valid" class="px-primary-btn-xs done-btn"
      (click)="onModuleFormSubmit()">SAVE</button>
  </div>
</div>
